import axios from 'axios/index';
import React, {PureComponent} from 'react';

import {Classes, Overlay, Button, MenuItem, Callout, Intent} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import InputRegular from '../common/InputRegular';
import TagsMultiselector from '../common/TagsMultiselector';
import ReactIntlTelInput from 'react-intl-tel-input-v2';
import countriesDialCodes from '../common/countriesDialCodes';


export default class AddContactModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        firstName: '',
        lastName: '',
        phone: {
            iso2: 'us',
            dialCode: '1',
            phone: ''
        },
        email: '',
        companyName: '',
        subscriptionType: 'Immediate',
        selectedTags: [],
        selectedTagsIds: [],
        contactId: ''
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false,
            firstName: '',
            lastName: '',
            phone: {
                iso2: 'us',
                dialCode: '1',
                phone: ''
            },
            email: '',
            companyName: '',
            subscriptionType: 'Immediate',
            selectedTags: [],
            selectedTagsIds: [],
            contactId: '',
            contactEditDataLoaded: false
        })
    }
    updateTags = async (tags) => {
        let selectedTagsIds = await [];
        await tags.map(tag => selectedTagsIds = [...selectedTagsIds, tag.id])
        await this.setState({selectedTags: tags, selectedTagsIds})
    }
    // updateTagsIds = async (tagIds) => {
    //     await this.setState({selectedTagsIds: tagIds})
    //
    // }
    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
        if (this.props.editContactCheck && this.props.editContactData) {
            let data = this.props.editContactData;
            let name = data.name ? data.name.substr(0, data.name.indexOf(' ')) : '';
            let lastName = data.name ? data.name.substr(data.name.indexOf(' ') + 1) : '';
            let callingCode = '';
            countriesDialCodes.find(code => data.phone.startsWith(code) ? callingCode = code : '')
            let iso2 = callingCode === '+1' ? 'us' : callingCode === '+44' ? 'gb' : callingCode === '+7' ? 'ru' : '';

            this.setState({
                firstName: name,
                lastName: lastName,
                phone: {
                    iso2,
                    dialCode: callingCode.substring(1),
                    phone: data.phone
                },
                email: data.email,
                companyName: data.company,
                subscriptionType: data.subscription_type,
                contactId: data.id
            })
        }
    }

    componentDidUpdate() {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if (!this.state.overlayIsOpen && (this.state.email || this.state.firstName || this.state.lastName || this.state.phone.phone || this.state.companyName)) {
            this.handleClose()
        }

        if (this.props.editContactCheck && this.props.editContactData && !this.state.phone.phone && this.state.overlayIsOpen &&
            !this.state.contactEditDataLoaded) {
            let data = this.props.editContactData;
            let name = data.name ? data.name.substr(0, data.name.indexOf(' ')) : '';
            let lastName = data.name ? data.name.substr(data.name.indexOf(' ') + 1) : '';
            let callingCode = '';
            countriesDialCodes.map(code => data.phone.startsWith(code) ? callingCode = code : '')
            let iso2 = callingCode === '+1' ? 'us' : callingCode === '+44' ? 'gb' : callingCode === '+7' ? 'ru' : '';
            let tagsIds = [];
            let tags = data.tags;
            tags.map(tag=>tagsIds.push(tag.id))

            this.setState({
                firstName: name,
                lastName: lastName,
                phone: {
                    iso2,
                    dialCode: callingCode.substring(1),
                    phone: data.phone
                },
                email: data.email,
                companyName: data.company,
                subscriptionType: data.subscription_type,
                contactId: data.id,
                contactEditDataLoaded: true,
                selectedTags: tags,
                selectedTagsIds: tagsIds
            })
        }
    }

    render() {
        const inputProps = {
            placeholder: '+' + this.state.phone.dialCode + ' *********',
        };

        const intlTelOpts = {
            preferredCountries: [],
        };

        const value = {iso2: 'sr', dialCode: '86', phone: '12345678901'};

        // const onChange = value => console.log('');
        // const onReady = (instance, IntlTelInput) => console.log(instance, IntlTelInput);
        return (
            <Overlay
                onClose={() => {
                    this.handleClose()
                    this.props.handleClose()
                }}
                className={Classes.OVERLAY_SCROLL_CONTAINER + ' z-index-20'} isOpen={this.state.overlayIsOpen}
                autoFocus={true}
                canEscapeKeyClose
                canOutsideClickClose={true}
                enforceFocus={true}
                hasBackdrop={true}
                usePortal={true}
                transitionDuration={100}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >

                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>{this.props.editContactCheck ? 'Edit Contact' : 'Add Contact'}</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>
                                <div className="form-group m-k-b">
                                    <div className="margin-bottom-10">
                                        <InputRegular
                                            id="1"
                                            label1="First Name"
                                            placeholder="First Name"
                                            type='text'
                                            onChange={value => this.setState({firstName: value})}
                                            value={this.state.firstName}
                                            required={false}
                                            // fieldsCheckActive={this.state.fieldsCheckActive}
                                            // updateErrorsList={this.updateErrorsList}
                                            // errorMessage="Amount can't be less than $20"
                                        />
                                    </div>

                                    <div className="margin-bottom-10">
                                        <InputRegular
                                            id="1"
                                            label1="Last Name"
                                            placeholder="Last Name"
                                            type='text'
                                            onChange={value => this.setState({lastName: value})}
                                            value={this.state.lastName}
                                            required={false}
                                            // fieldsCheckActive={this.state.fieldsCheckActive}
                                            // updateErrorsList={this.updateErrorsList}
                                            // errorMessage="Amount can't be less than $20"
                                        />
                                    </div>

                                    <div className="margin-bottom-10">
                                        <p htmlFor="post-link" className='full-row-label'>Phone</p>
                                        <ReactIntlTelInput
                                            className={this.state.phone.phone === '' ? '' : 'valid'}
                                            inputProps={inputProps}
                                            intlTelOpts={intlTelOpts}
                                            value={this.state.phone}
                                            onChange={(e) => {
                                                this.setState({
                                                    phone: e
                                                })
                                            }}
                                            // onReady={onReady}
                                        />
                                    </div>

                                    <div className="margin-bottom-10">
                                        <InputRegular
                                            id="1"
                                            label1="Email"
                                            placeholder="Email"
                                            type='text'
                                            onChange={value => this.setState({email: value})}
                                            value={this.state.email}
                                            required={false}
                                            // fieldsCheckActive={this.state.fieldsCheckActive}
                                            // updateErrorsList={this.updateErrorsList}
                                            // errorMessage="Amount can't be less than $20"
                                        />
                                    </div>

                                    <div className="margin-bottom-10">
                                        <InputRegular
                                            id="1"
                                            label1="Company Name"
                                            placeholder="Company Name"
                                            type='text'
                                            onChange={value => this.setState({companyName: value})}
                                            value={this.state.companyName}
                                            required={false}
                                            // fieldsCheckActive={this.state.fieldsCheckActive}
                                            // updateErrorsList={this.updateErrorsList}
                                            // errorMessage="Amount can't be less than $20"
                                        />
                                    </div>
                                    {/*<div className="margin-bottom-10 subscription-type-container">*/}
                                    {/*<p htmlFor="post-link" className='full-row-label'>Subscription Type</p>*/}
                                    {/*<Select*/}
                                    {/*items={['Immediate', 'Daily', 'Weekly']}*/}
                                    {/*itemRenderer={item =>*/}
                                    {/*<MenuItem*/}
                                    {/*key={item}*/}
                                    {/*text={item}*/}
                                    {/*onClick={() => this.setState({subscriptionType: item})}*/}
                                    {/*/>*/}
                                    {/*}*/}
                                    {/*// onItemSelect={(item) => this.setState({subscriptionType: item})}*/}
                                    {/*filterable={false}*/}
                                    {/*style={{width: '100%'}}*/}
                                    {/*>*/}
                                    {/*<div className="subscription-type-button">*/}
                                    {/*<p>{this.state.subscriptionType}</p>*/}
                                    {/*<i style={{color: 'black'}} className="fas fa-caret-down"></i>*/}
                                    {/*</div>*/}

                                    {/*</Select>*/}
                                    {/*</div>*/}
                                    {this.props.editContactCheck ?
                                        ''
                                        :
                                        <div className="margin-bottom-10 subscription-type-container">
                                            <p htmlFor="post-link" className='full-row-label'>Tags</p>
                                            <TagsMultiselector
                                                tags={this.props.tags}
                                                selectedTags={this.state.selectedTags}
                                                squareType={true}
                                                width={'100%'}
                                                updateTags={this.updateTags}
                                                // updateTagsIds={ this.updateTagsIds }
                                                handleCreateTag={this.props.handleCreateTag}
                                                handleGetTags={this.props.handleGetTags}
                                                dontHandleGetTags={true}
                                            />
                                        </div>
                                    }
                                </div>

                                {this.props.addContactError ?
                                    <Callout
                                        intent={'danger'}
                                    >{this.props.addContactError}</Callout>
                                    : ''}

                                {this.props.editContactError ?
                                    <Callout
                                        intent={'danger'}
                                    >{this.props.editContactError}</Callout>
                                    : ''}


                                <div className="flex-direction-row justify-content-end margin-top-20 margin-bottom-10">

                                    <button disabled={false}
                                            onClick={this.props.handleClose}
                                            name="cancel_team"
                                            id="cancel_team"
                                            type="button"
                                            className='btn-white-border margin-right-10'>Cancel
                                    </button>

                                    {this.props.editContactCheck ?
                                        <button
                                            disabled={false}
                                            onClick={() => {
                                                this.props.editContact({
                                                    "phone": this.state.phone,
                                                    "name": this.state.firstName + ' ' + this.state.lastName,
                                                    "email": this.state.email,
                                                    "company": this.state.companyName,
                                                    "subscription_type": "daily",
                                                    "contactId": this.state.contactId,
                                                    "tags": this.state.selectedTagsIds
                                                })
                                                // this.props.handleClose()
                                            }}
                                            name="cancel_delete_tag"
                                            id="cancel_delete_tag"
                                            type="button"
                                            className='btn-action'>Save {this.props.editContactLoader ?
                                            <i className='fa fa-spin fa-spinner'></i> : ''}</button>
                                        :
                                        <button
                                            disabled={false}
                                            onClick={() => {
                                                this.props.saveContact({
                                                    "phone": this.state.phone,
                                                    "name": this.state.firstName + ' ' + this.state.lastName,
                                                    "email": this.state.email,
                                                    "company": this.state.companyName,
                                                    "subscription_type": "daily",
                                                    "tags": this.state.selectedTagsIds
                                                })
                                                // this.props.handleClose()
                                            }}
                                            name="cancel_delete_tag"
                                            id="cancel_delete_tag"
                                            type="button"
                                            className='btn-action'>Add
                                            Contact {this.props.saveContactLoader ?
                                                <i className='fa fa-spin fa-spinner'></i> : ''}</button>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </Overlay>
        )
    }
}